import * as React from 'react';
import { createStyles } from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

// Components
import { DebouncedInput } from '../DebouncedInput';

const useStyles = createStyles(() => ({
    searchInput: {
        input: {
            borderRadius: '2rem'
        }
    },

    invisible: {
        pointerEvents: 'none',
        opacity: 0
    }
}));

interface SearchInputProps {
    value: string;
    setter: (updater: any) => void;
    disabled?: boolean;
    className?: string;
    placeholder?: string;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
    ({ className = '', value = '', setter, disabled, placeholder }, ref) => {
        const { classes, cx } = useStyles();
        const { t } = useTranslation('components', { keyPrefix: 'tables.common' });
        const defaultPlaceholder = t('defaultSearchPlaceholder');

        return (
            <DebouncedInput
                ref={ref}
                value={value ?? ''}
                onChange={(value) => setter(String(value))}
                className={cx(classes.searchInput, {
                    [className]: className
                })}
                icon={<IconSearch size={14} />}
                disabled={disabled}
                rightSection={
                    <IconX className={cx('', { [classes.invisible]: !value })} onClick={() => setter('')} size={14} />
                }
                placeholder={placeholder ?? defaultPlaceholder}
            />
        );
    }
);
